import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  title,
  description,
  action,
  noPadding = false
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden ${className}`} data-id="element-235">
      {(title || description || action) && <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-start" data-id="element-236">
          <div data-id="element-237">
            {title && <h3 className="text-lg font-semibold text-slate-900" data-id="element-238">{title}</h3>}
            {description && <p className="text-sm text-slate-500 mt-1" data-id="element-239">{description}</p>}
          </div>
          {action && <div data-id="element-240">{action}</div>}
        </div>}
      <div className={noPadding ? '' : 'p-6'} data-id="element-241">{children}</div>
    </div>;
}